import { Link } from 'react-router';

import { AuthCard } from '@/components/AuthCard';
import { Button } from '@/components/ui/button';
import { useSession } from '@/lib/auth-client';

/**
 * A URL nothing claims.
 *
 * The destination depends on who is asking — someone signed in wants to get
 * back to their own portal, someone signed out wants the login page — so the
 * button says where it goes rather than "Go back".
 */
export function NotFoundPage() {
  const { data: session } = useSession();

  return (
    <AuthCard
      title="That page does not exist"
      description="The link may be old, or it may have a typo in it."
    >
      <Button asChild full size="lg">
        <Link to={session ? '/launch' : '/login'}>
          {session ? 'Back to your dashboard' : 'Sign in'}
        </Link>
      </Button>
    </AuthCard>
  );
}
